import { jwtDecode } from 'jwt-decode';

export const setAuthToken = (token) => {

  const timestamp = new Date().getTime()
  const tokensData = timestamp + 1 * 3600000
  const expiryTime = tokensData - Date.now(); 
  const expiryInSeconds = Math.floor(expiryTime / 1000); 
  document.cookie = `jwt=${token}; max-age=${expiryInSeconds}; path=/; secure; samesite=strict`;

};

export const getAuthToken = () => {
  const cookies = document.cookie.split(';');
  const jwtCookie = cookies.find(cookie => cookie.trim().startsWith('jwt='));

  return jwtCookie ? jwtCookie.split('=')[1] : null;
};

export const decodedToken = () => {
  const token = getAuthToken();
  if (token) {
    try {
      const decoded = jwtDecode(token);
      if (decoded.exp && decoded.exp < Date.now() / 1000) {
        console.warn('Token expired');
        removeAuthToken(); 
        return null;
      }
      
      return decoded;
    } catch (error) {
      console.error('Invalid token:', error);
      removeAuthToken();
      return null;
    }
  }
  return null;
};

//updateToken
export const updateUserTypeInToken = (newUserType) => {
  const token = getAuthToken();
  if (!token) {
    console.error('No token found to update');
    return null;
  }

  try {
    
    const decoded = jwtDecode(token);
    console.log('Original Decoded Token:', decoded);

    decoded.userType = newUserType;

    const [header, payload, signature] = token.split('.');
    const updatedPayload = btoa(JSON.stringify(decoded)).replace(/=/g, ''); 
    const updatedToken = `${header}.${updatedPayload}.${signature || ''}`; 

    const expires = new Date();
    expires.setDate(expires.getDate() + 1); 
    document.cookie = `jwt=${updatedToken}; expires=${expires.toUTCString()}; path=/`;

    return updatedToken;
  } catch (error) {
    console.error('Error updating token:', error);
    return null;
  }
};

export const removeAuthToken = () => {
  document.cookie = 'jwt=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure; samesite=strict';
  sessionStorage.clear();
  localStorage.clear();
  // Redirect without full reload to avoid blank—use navigate in components or window.location.href = '/login';
  window.location.href = '/';
};